import store from '@/store/store';
import eventbus from 'tiny-emitter/instance';
import { useActions } from './store/useStore';
import { LAYOUT, RENDERER_MODE } from './constants';
import { lastUsedSectionFontSize } from './core/utils/index';

export const initSeatmap = (app, reInit = false) => {
  const { loadCategories } = useActions('categories');
  const { loadPosList } = useActions('pos');
  const { changeLayout, setDrawingMode, enableSelection } = useActions('settings');

  const initRenderer = async () => {
    const content = await loadSeatmap();

    loadCategories(app.props.categoriesList);
    loadPosList(app.props.posList);

    if (content) {
      initSeatmapRenderer(content);
    } else {
      finishLoading();
    }
  };

  const initDesigner = async () => {
    let content = await loadSeatmap();

    if (!content && app.props.bgImage) {
      content = { seatmap: { bgImage: { bgImage: app.props.bgImage } } };
    }

    loadCategories(app.props.categoriesList);
    loadPosList(app.props.posList);

    if (content) {
      initSeatmapDesigner(content, reInit);
    } else {
      finishLoading();
    }
  };

  const loadSeatmap = async () => {
    if (app.props.demo && (import.meta.env.VITE_APP_STANDALONE_MODE === 'true' || import.meta.env.DEV)) {
      try {
        const response = await fetch(`/demo-data/${app.props.demo}`);
        if (response.ok) {
          app.props.json = await response.json();
        } else {
          console.error(`Demo file not found: ${app.props.demo}`);
        }
      } catch (error) {
        console.error(`Error loading demo file: ${app.props.demo}`, error);
      }
    }

    if (app.props.json) {
      const content = typeof app.props.json === 'string' ? JSON.parse(app.props.json) : app.props.json;

      // Migrate zones to sections
      content.seatmap.layout = content.seatmap.layout === LAYOUT.ZONES ? LAYOUT.SECTIONS : content.seatmap.layout;

      return content;
    }
  };

  const initSeatmapRenderer = (rendererContent) => {
    setTimeout(async () => {
      changeLayout(rendererContent.seatmap.layout);

      if (rendererContent.seatmap.scale !== undefined) {
        store.commit('camera/setScale', rendererContent.seatmap.scale);
      }

      await app.seatmap.initSeatmap({ state: rendererContent.seatmap }, false, rendererContent.orders);

      finishLoading();
    }, 300);
  };

  const initSeatmapDesigner = (designerContent, reInit = false) => {
    if (designerContent.seatmap.layout !== undefined) {
      changeLayout(designerContent.seatmap.layout);
      setDrawingMode();
      enableSelection();
    } else {
      changeLayout(LAYOUT.NOTSELECTED);
    }

    if (designerContent.seatmap.scale !== undefined) {
      store.commit('camera/setScale', designerContent.seatmap.scale);
    }

    app.seatmap.initSeatmap({ state: designerContent.seatmap }, reInit);
    finishLoading();
    // Update store based on designerContent values
    if (designerContent.seatmap.showLabels !== undefined)
      store.commit('seatmap/showLabels', designerContent.seatmap.showLabels);
    if (designerContent.seatmap.showLocks !== undefined)
      store.commit('seatmap/showLocks', designerContent.seatmap.showLocks);
    if (designerContent.seatmap.snapToGrid !== undefined)
      store.commit('camera/snapToGrid', designerContent.seatmap.snapToGrid);
    if (designerContent.seatmap.showGrid !== undefined)
      store.commit('camera/toggleGrid', designerContent.seatmap.showGrid);
    if (designerContent.seatmap.lastUsedSectionFontSize !== undefined)
      lastUsedSectionFontSize.value = designerContent.seatmap.lastUsedSectionFontSize;
    if (app.props.name) store.commit('camera/seatmapName', app.props.name);

    eventbus.emit('history:snapshot', 'Seatmap loaded', true);
  };

  const finishLoading = () => {
    if (document.getElementById('appspinner') !== null) {
      document.getElementById('appspinner').style.display = 'none';
    }
    if (typeof app.props.onLoadFinish === 'function') {
      app.props.onLoadFinish();
    }
  };

  if (RENDERER_MODE) {
    initRenderer().then(() => eventbus.emit('seatmap:loaded'));
  } else {
    initDesigner().then(() => eventbus.emit('seatmap:loaded'));
  }
};
